<template>
  <section class="scene">
    <!-- background -->
    <div class="underlay bg-gradient-night">
      <!-- moon -->
      <picture>
        <source
          srcset="@/assets/images/night/moon.webp 700w"
          type="image/webp"
          sizes="600px"
        >
        <img
          class="moon"
          alt="Moon"
          src="@/assets/images/night/moon.png"
          srcset="@/assets/images/night/moon.png 700w"
          width="604"
          height="598"
          sizes="600px"
        >
      </picture>
      <!-- stars -->
      <picture>
        <source
          srcset="@/assets/images/night/stars_sm.webp 700w, @/assets/images/night/stars.webp 1400w"
          type="image/webp"
          sizes="100vw"
        >
        <img
          class="underlay stars"
          alt="Stars"
          src="@/assets/images/night/stars_sm.png"
          srcset="@/assets/images/night/stars_sm.png 700w, @/assets/images/night/stars.png 1400w"
          width="500"
          height="160"
          sizes="100vw"
        >
      </picture>
      <!-- star -->
      <picture v-for="starIndex in 4" :key="`star-${starIndex}`">
        <source
          :srcset="require(`@/assets/images/night/star${starIndex}_sm.webp`) + ` 700w, ` + require(`@/assets/images/night/star${starIndex}.webp`) + ` 1400w`"
          type="image/webp"
          sizes="100vw"
        >
        <img
          :class="`underlay star star--${starIndex}`"
          :alt="`Star ${starIndex}`"
          :src="require(`@/assets/images/night/star${starIndex}_sm.png`)"
          :srcset="require(`@/assets/images/night/star${starIndex}_sm.png`) + ` 700w, ` + require(`@/assets/images/night/star${starIndex}.png`) + ` 1400w`"
          width="500"
          height="160"
          sizes="100vw"
        >
      </picture>
      <!-- cloud -->
      <picture v-for="cloudIndex in 4" :key="`cloud-${cloudIndex}`">
        <source
          :srcset="require(`@/assets/images/night/cloud${cloudIndex}.webp`) + ` 700w`"
          type="image/webp"
          sizes="100vw"
        >
        <img
          :class="`cloud cloud--${cloudIndex}`"
          :alt="`Cloud ${cloudIndex}`"
          :src="require(`@/assets/images/night/cloud${cloudIndex}.png`)"
          :srcset="require(`@/assets/images/night/cloud${cloudIndex}.png`) + ` 700w`"
          sizes="100vw"
          width="600"
          height="155"
        >
      </picture>
    </div>
    <!-- character -->
    <div class="dragon">
      <div class="dragon__inner">
        <div class="dragon__image">
          <img alt="Character" src="@/assets/images/people/sprinkles/right/0.png" width="184" height="172">
          <img alt="Character" src="@/assets/images/people/sprinkles/right/1.png" width="184" height="172">
          <img alt="Character" src="@/assets/images/people/sprinkles/right/2.png" width="184" height="172">
          <img alt="Character" src="@/assets/images/people/sprinkles/right/3.png" width="184" height="172">
        </div>
      </div>
    </div>
    <!-- content -->
    <div class="content">
      <div class="container">
        <picture>
          <source
            srcset="@/assets/images/night/heading_sm.webp 700w, @/assets/images/night/heading.webp 1400w"
            type="image/webp"
            sizes="100vw"
          >
          <img
            class="heading"
            alt="Heading"
            src="@/assets/images/night/heading_sm.png"
            srcset="@/assets/images/night/heading_sm.png 700w, @/assets/images/night/heading.png 1400w"
            width="500"
            height="158"
            sizes="100vw"
          >
        </picture>
        <button class="btn btn--pink btn--half pagelink" @click="$store.dispatch('setScene', 'village')">
          Discover MapleStory
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Night',

  computed: {
    sceneName () {
      return this.$store.getters.getSceneName
    }
  },

  mounted () {
    this.$gtm.trackEvent({
      'event': 'View Landing Page Section',
      'lp_section': this.sceneName,
      'lp_loc': '0'
    })
  }
}
</script>

<style scoped lang="scss">
.star {
  &--1 {
    animation: star 5s infinite;
  }
  &--2 {
    animation: star 6s infinite 1s;
  }
  &--3 {
    animation: star 7s infinite 2s;
  }
  &--4 {
    animation: star 8s infinite 3s;
  }
}
.moon {
  position: absolute;
  z-index: 0;
  top: 0%;
  left: 5%;
  width: 400px;
  height: auto;
}
.cloud {
  position: absolute;
  z-index: 1;
  height: auto;

  &--1 {
    top: 62%;
    left: 49%;
    width: 780px;
    animation: cloudsLeft 10s forwards;
  }
  &--2 {
    top: 70%;
    left: 5%;
    width: 750px;
    animation: cloudsLeft 20s forwards;
  }
  &--3 {
    top: 16%;
    left: 5%;
    width: 600px;
    animation: cloudsLeft 30s forwards;
  }
  &--4 {
    top: 49%;
    left: 15%;
    width: 600px;
    animation: cloudsLeft 40s forwards;
  }
}
.heading {
  margin: 0 auto;
  max-width: 1200px;
  opacity: 0;
  animation: fadeIn 2s forwards .5s;
}
.content {
  .btn {
    opacity: 0;
    animation: fadeIn 2s forwards 1s;
  }
}
.dragon {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  pointer-events: none;
}
.dragon__inner {
  width: 184px;
  overflow: hidden;
  opacity: 0;
  filter: brightness(0);
  animation: dragon-fade 7s forwards;
}
.dragon__image {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  transform: translate3d(0, 0, 0);
  animation: dragon-animate .7s steps(3) infinite 1s;

  img {
    display: block;
    width: 184px;
  }
}

@keyframes dragon-animate {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-184px * 3, 0, 0);
  }
}
@keyframes dragon-fade {
  0% {
    opacity: 0;
    filter: brightness(0);
    transform: translate3d(0, 0, 0) scale(.7);
  }
  10% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    filter: brightness(1);
    transform: translate3d(50vw, 25vh, 0) scale(1);
  }
}
@keyframes cloudsLeft {
  0% {
    transform: translate3d(100px, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes star {
  0% {
    opacity: 1;
  }
  5% {
    opacity: .6;
  }
  10% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
</style>
